/**
 * Validate if the user has access to dealer group views
 * @param {Object} user - the graphql user object
 * @param {Object[]} dealers - the graphql dealers array
 * @returns {boolean} true if the user has access to dealer group views
 */
export function hasDealerGroupAccess (user, dealers) {
  return user.role === 'ADMINISTRATOR' || dealers?.length > 1
}
